var map = {
	"./bootstrap-original.svg": 133,
	"./c-original.svg": 897,
	"./csharp-original.svg": 716,
	"./css3-original-wordmark.svg": 616,
	"./de.svg": 530,
	"./discordjs-original.svg": 186,
	"./docker-plain.svg": 601,
	"./fr.svg": 808,
	"./gb.svg": 446,
	"./git-original.svg": 30,
	"./github-original.svg": 890,
	"./html5-original-wordmark.svg": 481,
	"./java-original-wordmark.svg": 729,
	"./javascript-original.svg": 459,
	"./laravel-plain-wordmark.svg": 39,
	"./mariadb.svg": 15,
	"./mysql-original-wordmark.svg": 902,
	"./nextjs-original.svg": 200,
	"./nodejs-original.svg": 765,
	"./php-original.svg": 631,
	"./python-original.svg": 240,
	"./react-original.svg": 961,
	"./tailwindcss-plain.svg": 657,
	"./typescript-original.svg": 22,
	"./unity-original.svg": 989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;